var c3 = require('c3');
var c3Styles = require('../../../stylesheets/vendor/c3.css');
var m = require('mithril');
var modal = require('../../layout/components/modal');

var weatherChart = {
  oncreate: function (vnode) {
    this.temperature = vnode.attrs.weather?.temperature;
    this.precipitation = vnode.attrs.weather?.precipitation;

    var temperature = (this.temperature || []).map(function (r) { return (r.value * 9 / 5) + 32; });
    var temperatureDates = (this.temperature || []).map(function (r) { return new Date(r.time); });
    var precipitation = (this.precipitation || []).map(function (r) { return r.value; });
    var precipitationDates = (this.precipitation || []).map(function (r) { return new Date(r.time); });

    var defaultConfig = {
      size: {
        height: 230
      },
      legend: {
        position: 'inset'
      },
      zoom: {
        enabled: false
      },
      data: {
        xs: {
          'Temperature': 'TemperatureDates',
          'Precipitation': 'PrecipitationDates'
        },
        columns: [
          ['Temperature', ...temperature],
          ['TemperatureDates', ...temperatureDates],
          ['Precipitation', ...precipitation],
          ['PrecipitationDates', ...precipitationDates]
        ],
        axes: {
          Temperature: 'y',
          Precipitation: 'y2'
        },
        types: {
          Temperature: 'spline',
          Precipitation: 'bar'
        },
        colors: {
          Temperature: '#1f77b4',
          Precipitation: '#aec7e8'
        }
      },
      point: {
        show: false
      },
      axis: {
        x: {
          type: 'timeseries',
          tick: {
            format: '%m/%d/%Y %I:%M %p',
            count: 7
          }
        },
        y: {
          tick: {
            format: function (y) { return y + '°'; }
          }
        },
        y2: {
          show: true,
          tick: {
            format: function (y) { return y + ' %'; }
          },
          max: 100,
          min: 0,
          padding: { top: 0, bottom: 0 }
        }
      }
    };

    this.chart = c3.generate(Object.assign({}, defaultConfig, { bindto: vnode.dom }));
  },
  onupdate: function (vnode) {
    var chart = vnode.state.chart;
    (function () {
      var elementDiv = document.getElementById(vnode.attrs.idDiv);
      if (elementDiv && vnode.attrs.resize) {
        var heigthDiv = elementDiv.offsetHeight;
        var widthDiv = elementDiv.offsetWidth;
        chart.resize({ height: heigthDiv, width: widthDiv });
      }
    })();
  },
  view: function () {
    window.addEventListener('resize', m.redraw);
    return m('div');
  }
};

function getCurrentConditions(weather) {
  var weatherData = weather || {};
  var temperatureReading = Array.isArray(weatherData.temperature) ? weatherData.temperature[0] : null;
  var precipitationReading = Array.isArray(weatherData.precipitation) ? weatherData.precipitation[0] : null;

  var hasTemperatureValue = temperatureReading && typeof temperatureReading.value === 'number';
  var temperatureActual = hasTemperatureValue ? Math.round((temperatureReading.value * 9 / 5) + 32) : null;
  var precipitationValue = precipitationReading && typeof precipitationReading.value === 'number'
    ? precipitationReading.value
    : null;

  var icon = 'ion-ios-partlysunny';
  if (precipitationValue !== null) {
    if (precipitationValue < 20) icon = 'ion-ios-sunny';
    else if (precipitationValue > 30) icon = 'ion-ios-rainy';
  }

  var temperatureDisplay = (typeof temperatureActual === 'number' ? temperatureActual : '--') + '° F';

  return {
    icon: icon,
    temperatureDisplay: temperatureDisplay
  };
}

function hasWeatherData(weather) {
  if (!weather) return false;
  var hasTemperature = Array.isArray(weather.temperature) && weather.temperature.length > 0;
  var hasPrecipitation = Array.isArray(weather.precipitation) && weather.precipitation.length > 0;
  return hasTemperature || hasPrecipitation;
}

weatherChart.openModal = function (options) {
  var weatherData = options && options.weather ? options.weather : {};
  var locationLabel = options && options.locationName ? options.locationName : 'Site';

  modal.vm.title(locationLabel + ' Forecast');
  modal.vm.body = function () {
    return m('div', [
      hasWeatherData(weatherData)
        ? m(weatherChart, { weather: weatherData })
        : m('div.tc.f4', 'No weather data available.')
    ]);
  };
  modal.vm.buttons([
    {
      label: 'Close',
      class: 'dib',
      func: modal.vm.close
    }
  ]);
  modal.vm.open({ extrawidth: true });
};

weatherChart.renderToggle = function (options) {
  var location = options && options.location ? options.location : null;
  if (!location || location['@class'] !== 'Site') return null;

  var weather = location.weather || {};
  var conditions = getCurrentConditions(weather);

  var openModal = function () {
    weatherChart.openModal({
      weather: weather,
      locationName: location.name || 'Site'
    });
  };

  var handleKey = function (event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      openModal();
    }
  };

  return m('div.f1.flex.mr3.items-center.pointer', {
    style: { 'margin-left': 'auto' },
    role: 'button',
    tabindex: 0,
    onclick: openModal,
    onkeypress: handleKey
  }, [
    m('span.blue', conditions.temperatureDisplay),
    m('i.ml2.blue' + conditions.icon)
  ]);
};

module.exports = weatherChart;
